var exports = {
  "q9": "xa15a2ab7--3b6a56--price",
  "vj": "xa15a2ab7--3b6a56--amount",
  "vE": "xa15a2ab7--3b6a56--coworking-additional-info",
  "b6": "xa15a2ab7--3b6a56--history",
};

module.exports = exports;
